var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStatsf0A18011(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 47 40",
    width: 47,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#03cfcd",
    height: 32,
    rx: 4,
    width: 40
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#303fd0",
    height: 32,
    rx: 4,
    width: 40,
    x: 7,
    y: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4 0h29a0 0 0 0 1 0 0v20a4 4 0 0 1 -4 4h-29a0 0 0 0 1 0 0v-20a4 4 0 0 1 4-4z",
    fill: "#50d0fe",
    transform: "translate(7 8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.876-27.5h-11.991a2.437 2.437 0 0 0 -1.724 4.161l3.291 3.291-7.452 7.448-7.452-7.452a3.249 3.249 0 0 0 -4.6 0l-6.972 6.981a1.625 1.625 0 0 0 0 2.3l2.3 2.3a1.625 1.625 0 0 0 2.3 0l4.678-4.679 7.446 7.45a3.249 3.249 0 0 0 4.6 0l9.75-9.75 3.291 3.291a2.438 2.438 0 0 0 4.159-1.726v-11.99a1.623 1.623 0 0 0 -1.624-1.625z",
    fill: "#fff",
    transform: "translate(-3.5 37.75)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatsf0A18011);
export default __webpack_public_path__ + "static/media/ic_stats.f0a18011.f0a18011f34ad3ae0cde3c5949cf6555.svg";
export { ForwardRef as ReactComponent };